import React, { useEffect, useState } from 'react';

import { Col, Row, Form, Table } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import './styles.css';

import Menu from '../../components/Menu';

import search from '../../assets/images/search.png';
import ativo from '../../assets/images/ativo.png';
import naoAtivo from '../../assets/images/naoativo.png';
import editar from '../../assets/images/edit.png';
import excluir from '../../assets/images/delete.png';
import api from '../../services/api';
import CustomModal from '../../components/CustomModal';
import { useAlert } from 'react-alert';

const Macumbas = () => {

  const [macumbas, setMacumbas] = useState([]);
  const [searchString, setSearchString] = useState('');
  const [show, setShow] = useState(false);
  const [idDelete, setIdDelete] = useState(null);
  const [load, setLoad] = useState(false);

  const alert = useAlert();

  const getMacumbas = async (search = '') => {
    try {
      const { data: { resources }
      } = await api.get('admin/macumba', { params: { search } });
      setMacumbas(resources.data ?? []);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      console.log(error.response);
    }
  }


  useEffect(() => {
    getMacumbas();
  }, []);

  // const handleStatus = async id => {
  //   try {
  //     const { data: { resources }
  //     } = await api.post(`admin/macumba/${id}/status`);
  //     console.log(resources);
  //     setMacumba(resources.data);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  const handleDelete = async id => {
    setShow(true);
    setIdDelete(id);
  }
  const finishDelete = async () => {
    try {
      const { data: { resources }
      } = await api.delete(`admin/macumba/${idDelete}`);
      setMacumbas(resources.data);
      alert.show("Dados removidos com sucesso!");
    } catch (error) {
      console.log(error);
    }
    setShow(false);
  }
  const handleSearch = (e) => {
    const value = e.target.value;
    setLoad(true);
    setSearchString(value);
    getMacumbas(value);
  }

  const handleShow = () => setShow(false);

  return (
    <div className="container-fluid">
      <CustomModal show={show} handleShow={handleShow} onDelete={finishDelete} />
      <Menu />
      <div className="content">
        <Row>
          <Col sm={12} className="col-title">
            <div className="titlePages">
              <h5>Rotas de Macumba</h5>
              <Link to="/rota-macumba/novo">
                <button className="btnYellow">NOVO</button>
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Form className="formSearch">
              <Form.Group controlId="formBasicEmail">
                <Form.Control type="text" placeholder="Buscar" name="search" value={searchString} onChange={handleSearch} />
                <button><img src={search} alt="Icon" /></button>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col sm={10}>
            {load &&
              <div className="load-table">
                <div className="loading"></div>
              </div>
            }
            <Table responsive>
              <thead>
                <tr>
                  <th className="tableLeft">Nome</th>
                  {/* <th>Ativo</th> */}
                  <th>Editar</th>
                  <th>Excluir</th>
                </tr>
              </thead>
              <tbody>
                {macumbas.map((macumba, key) => (
                  <tr key={key}>
                    <td className="tableLeft">{macumba.name}</td>
                    {/* <td><img className="imgActive" src={macumba.status === 1 ? ativo : naoAtivo} alt="Icon" onClick={() => handleStatus(macumba.id)} />{macumba.status === 1 ? 'Sim' : 'Não'}</td> */}
                    <td>
                      <Link to={`rota-macumba/edit/${macumba.id}`}>
                        <img className="imgEdit" src={editar} alt="Icon" />
                      </Link>
                    </td>
                    <td><img className="imgDelete" src={excluir} onClick={() => handleDelete(macumba.id)} alt="Icon" /></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Macumbas;